import { render, staticRenderFns } from "./SchoolClassPicker.vue?vue&type=template&id=1f33472c"
import script from "./SchoolClassPicker.vue?vue&type=script&lang=js"
export * from "./SchoolClassPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports